import { useEffect, useState } from 'react';
import { hoverSupportMedia } from '../../constants';
import { isBrowser } from '../utils';
export const useSupportsHover = () => {
    const [supportsHover, setSupportsHover] = useState(() => {
        if (isBrowser && window && window.matchMedia) {
            return window.matchMedia(hoverSupportMedia).matches;
        }
        return null;
    });
    useEffect(() => {
        const handleMqlChange = (event) => {
            setSupportsHover(event.matches);
        };
        const mql = window.matchMedia(hoverSupportMedia);
        mql.addEventListener('change', handleMqlChange);
        return () => mql.removeEventListener('change', handleMqlChange);
    }, []);
    return supportsHover;
};
//# sourceMappingURL=useSupportsHover.js.map